/* eslint-disable no-unreachable */
import axios from 'axios';
import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import Lightbox from 'react-awesome-lightbox';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';
import PlayCircleFilledRoundedIcon from '@material-ui/icons/PlayCircleFilledRounded';
import Navbar from '../../components/navBar/navBar';
import Loading from '../../components/loading/loading';
import CustomAlert from '../../components/CustomAlert/CustomAlert';
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer';
import {
  apiList,
  dencrypt,
  variables,
  verifyLogin,
  encrypt,
  shortDate,
  shortDecimal,
} from '../../helpers';
import '../../assets/style/lightbox.css';
import '../../assets/style/constructionDetails.scss';
import CustomModal from '../../components/CustomModal/CustomModal';
import FormUpdateStatus from './FormUpdateStatus';
import { groupDataByFloorName, groupDataByactivityTypeAndName } from '../../helpers/utils';
import TransferMedia from './TransferMedia/TransferMedia';
import ModifyPlan from './ModifyPlan/ModifyPlan';

const videoAvatar = require('../../assets/images/videoAvatar.mp4').default;

const successTimeOut = variables.SUCCESS_TIMEOUT;
const errorTimeOut = variables.SUCCUSS_TIMEOUT;
// Who can submit progress media. Only types that actually have media are
// shown; Customer is preferred when it has any.
// "Transfer Media" is hidden until the feature is reworked (see Backlog).
const SHOW_TRANSFER_MEDIA = false;
const MEDIA_TABS = ['Customer', 'Relationship Manager',
  'Contractor', 'Valuer'];

const mapsUrl = (lat, lng) => `https://www.google.com/maps/place/${lat},${lng}`;

const statusClass = (status) => {
  switch (status) {
    case 'Verified': return 'verified';
    case 'Submitted':
    case 'Uploading': return 'submitted';
    case 'In Progress': return 'progress';
    default: return '';
  }
};

// Same marks as before: filled tick = verified, outline tick = submitted / in progress.
const StatusIcon = ({ status }) => {
  if (status === 'Verified') {
    return <CheckCircleRoundedIcon className='cd-status-icon verified' titleAccess='Verified' />;
  }
  if (status === 'Submitted' || status === 'In Progress') {
    return <CheckCircleOutlineRoundedIcon className='cd-status-icon progress' titleAccess={status} />;
  }
  return null;
};

const FloorTabs = withStyles({
  root: { minHeight: 52 },
  indicator: { height: 3, borderRadius: 3, backgroundColor: '#2E3B6E' },
})(Tabs);

const FloorTab = withStyles({
  root: {
    minHeight: 52,
    minWidth: 0,
    padding: '6px 16px',
    textTransform: 'none',
    fontSize: 15,
    fontWeight: 500,
    color: '#5B6472',
    opacity: 1,
    '&$selected': { color: '#1F2733', fontWeight: 600 },
  },
  wrapper: { flexDirection: 'row', gap: 6 },
  selected: {},
})(Tab);

class ConstructionDetails extends Component {
  constructor() {
    super();
    this.state = {
      selectedConstructionPlanIndex: -1,
      propertyId: null,
      result: false,
      data: {},
      dataLoaded: false,
      showAlert: false,
      viewerIsOpen: false,
      currentImage: 0,
      selectedPhotos: [],
      photos: [],
      videos: [],
      videoOpen: false,
      videoUrl: '',
      selectedVideodisc: '',
      selectedVideoTitle: '',
      permission: {},
      modifyPermission: {},
      remarks: '',
      status: '',
      floorTab: 0,
      componentTab: 0,
      mediaTab: 0,
      planList: [],
      selectedComponent: [],
      selectedItem: null,
      progressMedia: [],
      mediaAvailability: {},
      transferMediaOpen: false,
      isCurrentPlan: true,
      constructionPlanVersion: 'undef',
      modifyPlanOpen: false,
      selectedConstructionPlanId: -1,
    };
  }

  componentDidMount() {
    const detailId = dencrypt(this.props.match.params.detailId);
    const data = JSON.parse(detailId);
    this.setState({
      selectedConstructionPlanIndex: data.index,
      selectedConstructionPlanId: data.planId,
      propertyId: data.propertyId,
      isCurrentPlan: data.isCurrentPlan,
      constructionPlanVersion: data.constructionPlanVersion,
    });
    this.setState({ result: true });
    // Links for one item (e.g. from the progress-report panel) pass its planId
    // along with the activity index: open on that item's floor / component.
    this.focusPlanId = data.index !== null && data.index !== undefined ? data.planId : null;
    this.getConstructionPlan(data.index, data.planId,
      data.propertyId, null, data.constructionPlanVersion);
    const { roleMapping, user } = verifyLogin();
    if (user.userRoleId === 1 || user.userRoleId === 2) {
      this.setState({
        permission: {
          view: true, add: true, edit: true, delete: true,
        },
        modifyPermission: {
          view: true, add: true, edit: true, delete: true,
        },
      });
    } else {
      const permission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Construction Plan');
      const modifyPermission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'CP-Transfer Media');
      this.setState({ permission: permission || {}, modifyPermission: modifyPermission || {} });
    }
  }

  handleChange(key) {
    key.preventDefault();
    this.setState({ [key.target.id]: key.target.value });
  }

  handleOpenMedia(key, media) {
    key.preventDefault();
    window.open(media, '_blank', 'height= 500px, width= 800px');
  }

  handleVerify() {
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Construction Plan', feature: 'edit' } };
    if (this.state.remarks.length < 1 || this.state.status.length < 1) {
      toast.error('All fields are mandatory.');
      return;
    }
    const params = {
      status: this.state.status,
      id: this.state.data?.constructionPlan?.id || -1,
      remarks: this.state.remarks,
    };

    axios.post(`${apiList.VERIFY_CONSTRUCTION_PLAN}`, params, config)
      .then((response) => {
        toast.success(response.data.message);
        this.getConstructionPlan(this.state.selectedConstructionPlanIndex,
          this.state.selectedConstructionPlanId,
          this.state.propertyId, this.state.selectedItem, this.state.constructionPlanVersion);
        this.setState({
          result: false, showAlert: false, formOpen: false, status: '', remarks: '',
        });
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);
        setTimeout(() => {
          this.setState({ result: false });
        }, 1000);
      });
  }

  getConstructionPlan(index, planId, propertyId, selectedItem, constructionPlanVersion) {
    this.setState({ result: true });
    axios.get(`${apiList.VIEW_CONSTRUCTION_PLAN_API}/${propertyId}/${constructionPlanVersion}`)
      .then((response) => {
        if (response?.data?.result) {
          const { constructionPlan } = response.data.result;
          let planData = [];
          if (index !== null) {
            const groupedPlan = groupDataByactivityTypeAndName(constructionPlan);
            planData = groupedPlan[index].data;
          } else {
            const groupedPlan = groupDataByactivityTypeAndName(constructionPlan.filter(
              (plan) => plan.id === planId,
            ));
            planData = groupedPlan[0].data;
          }
          const planList = groupDataByFloorName(planData);
          let { floorTab, componentTab } = this.state;
          if (this.focusPlanId) {
            const focusFloor = planList.findIndex(
              (floor) => floor.data.some((item) => item.id === this.focusPlanId),
            );
            if (focusFloor !== -1) {
              floorTab = focusFloor;
              componentTab = planList[focusFloor].data
                .findIndex((item) => item.id === this.focusPlanId);
            }
            this.focusPlanId = null;
          }
          const itemId = selectedItem || planList[floorTab]?.data[componentTab]?.id;
          this.setState({
            planList,
            floorTab,
            componentTab,
            selectedComponent: planList[floorTab]?.data,
            selectedItem: planList[floorTab]?.data[componentTab]?.id,
          });
          this.getProgressMedia(itemId);
          this.getData(itemId);
        }

        this.setState({ result: false });
      })
      .catch(() => {
        this.setState({ result: false });
      });
  }

  getData(id) {
    // Ignore replies for an item the user has already moved away from.
    this.dataSeq = (this.dataSeq || 0) + 1;
    const seq = this.dataSeq;
    const { session } = verifyLogin();
    const config = { headers: { session } };
    axios.get(`${apiList.VIEW_CONSTRUCTION_DETAILS_API}/${id}`, config)
      .then((response) => {
        if (seq !== this.dataSeq) return;
        if (response && response.data && response.data.result) {
          this.setState({
            data: { ...response.data.result },
            dataLoaded: true,
          });
        }
        setTimeout(() => {
          this.setState({ result: false });
        }, successTimeOut);
      })
      .catch((error) => {
        toast.error(`${error.message || error.response.message}`);

        setTimeout(() => {
          this.setState({ result: false });
        }, errorTimeOut);
      });
  }

  getProgressMedia(planID) {
    this.mediaSeq = (this.mediaSeq || 0) + 1;
    const seq = this.mediaSeq;
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Loan', feature: 'view' } };
    axios.get(`${apiList.GET_PROGRESS_MEDIA_BY_CONST_PLAN}?consPlanId=${planID}`, config)
      .then((response) => {
        if (seq !== this.mediaSeq) return;
        if (response.data.data) {
          const progressMedia = response.data.data.map(({
            url, submittedDate, lat, lng, ProgressMediaPlan, submittedUserType, id,
          }) => ({
            src: url,
            id,
            submittedDate,
            lat,
            lng,
            url,
            mediaType: ProgressMediaPlan.mediaType,
            width: 4,
            height: 3,
            caption: ProgressMediaPlan.title,
            title: ProgressMediaPlan.title,
            disc: ProgressMediaPlan.instruction,
            submittedUserType,
          }));

          const mediaAvailability = MEDIA_TABS.reduce((acc, type) => ({
            ...acc,
            [type]: progressMedia.some((item) => item.submittedUserType === type),
          }), {});
          // Show Customer media when there is any, otherwise the first type that has media.
          const available = MEDIA_TABS.filter((type) => mediaAvailability[type]);
          const type = mediaAvailability.Customer ? 'Customer' : (available[0] || 'Customer');

          this.setState({ progressMedia, mediaAvailability });
          this.selectSubmitter(type, progressMedia);
        }
      })
      .catch((error) => {
        toast.error(`${error.message || error.response.message}`);
      });
  }

  getViewLoanUrl(viewId) {
    const detailId = encrypt(viewId);
    return `/view-loan-details/${detailId}`;
  }

  body = () => (
    <FormUpdateStatus
      handleChange={(id) => this.handleChange(id)}
      remarks={this.state.remarks}
      setStatus={(event) => {
        this.setState({ status: event.target.value });
      }}
      status={this.state.status}
    />
  )

  // Show the media one submitter type sent in.
  selectSubmitter(type, progressMedia = this.state.progressMedia) {
    const media = progressMedia.filter((item) => item.submittedUserType === type);
    this.setState({
      mediaTab: MEDIA_TABS.indexOf(type),
      photos: media.filter((item) => item.mediaType === 'IMAGE'),
      videos: media.filter((item) => item.mediaType === 'VIDEO'),
    });
  }

  // Switch to another construction-plan item (floor / component) and load it.
  openItem(id, extraState) {
    this.setState({
      ...extraState,
      selectedItem: id,
      mediaTab: 0,
      photos: [],
      videos: [],
      progressMedia: [],
      mediaAvailability: {},
    });
    this.getData(id);
    this.getProgressMedia(id);
  }

  renderNavigation() {
    const {
      planList, floorTab, selectedComponent, componentTab,
    } = this.state;
    const showFloors = Array.isArray(planList) && planList.length > 0 && planList[0].floorName;
    const components = Array.isArray(selectedComponent) ? selectedComponent : [];
    const floorName = planList[floorTab]?.floorName;
    // The component row only adds something when the floor has several
    // components, or one whose name differs from the floor's.
    const showComponents = components.length > 0 && components[0].propertyComponentName
      && (components.length > 1 || components[0].propertyComponentName !== floorName);

    if (!showFloors && !showComponents) return null;
    return (
      <nav className='cd-card cd-nav' aria-label='Floors and components'>
        {showFloors ? (
          <div className='cd-nav-row'>
            <span className='cd-nav-label'>Floor</span>
            <FloorTabs
              value={floorTab}
              onChange={(event, newValue) => {
                this.openItem(planList[newValue]?.data[0]?.id, {
                  floorTab: newValue,
                  selectedComponent: planList[newValue]?.data,
                  componentTab: 0,
                });
              }}
              variant='scrollable'
              scrollButtons='auto'
            >
              {planList.map((item) => (item.floorName ? (
                <FloorTab
                  key={item.floorName}
                  label={(
                    <>
                      {item.floorName}
                      <StatusIcon status={item.status} />
                    </>
                  )}
                />
              ) : null))}
            </FloorTabs>
          </div>
        ) : null}
        {showComponents ? (
          <div className='cd-nav-row cd-components'>
            <span className='cd-nav-label'>Component</span>
            <div className='cd-pills' role='tablist'>
              {components.map((item, index) => (item.propertyComponentName ? (
                <button
                  key={item.id}
                  type='button'
                  role='tab'
                  aria-selected={componentTab === index}
                  className={`cd-pill ${componentTab === index ? 'active' : ''}`}
                  onClick={() => this.openItem(item.id, { componentTab: index })}
                >
                  {item.propertyComponentName}
                  <StatusIcon status={item.status} />
                </button>
              ) : null))}
            </div>
          </div>
        ) : null}
      </nav>
    );
  }

  renderActions() {
    const {
      data, photos, videos, permission, modifyPermission, mediaTab,
      isCurrentPlan, constructionPlanVersion,
    } = this.state;
    if (!isCurrentPlan || !data.constructionPlan) return null;
    return (
      <div className='cd-actions'>
        {modifyPermission.edit && constructionPlanVersion > 1 ? (
          <Button
            variant='outlined'
            color='primary'
            onClick={() => {
              this.setState({
                modifyPlanOpen: true,
                selectedTransferMedia: {
                  currentPlanActName: data.constructionPlan.activityConfigName,
                  currentPlanComponent:
                    data.constructionPlan.propertyComponentFloorName
                    || data.constructionPlan.activityTypeConfigName,
                  currentPlanID: data.constructionPlan.id,
                  noOfImages: data.constructionPlan.noOfImages,
                  noOfVideos: data.constructionPlan.noOfVideos,
                  submittedUser: mediaTab,
                  loanId: data.loan?.id,
                  constructionPlanVersion,
                },
              });
            }}
          >
            Get Progress
          </Button>
        ) : null}
        {SHOW_TRANSFER_MEDIA && permission.edit && (photos.length > 0 || videos.length > 0) ? (
          <Button
            variant='outlined'
            color='primary'
            onClick={() => {
              this.setState({
                transferMediaOpen: true,
                selectedTransferMedia: {
                  photos,
                  videos,
                  currentPlanActName: data.constructionPlan.activityConfigName,
                  currentPlanComponent:
                    data.constructionPlan.propertyComponentFloorName
                    || data.constructionPlan.activityTypeConfigName,
                  currentPlanID: data.constructionPlan.id,
                  submittedUser: MEDIA_TABS[mediaTab],
                  loanId: data.loan?.id,
                  mapCircleRadius: data.constructionPlan.mapCircleRadius,
                },
              });
            }}
          >
            Transfer Media
          </Button>
        ) : null}
        {permission.edit ? (
          <Button
            variant='contained'
            color='primary'
            onClick={() => { this.setState({ formOpen: true }); }}
          >
            Change Status
          </Button>
        ) : null}
      </div>
    );
  }

  renderDetails() {
    const { data, isCurrentPlan } = this.state;
    const plan = data.constructionPlan || {};
    const property = data.loanProperty;
    return (
      <div className='cd-details'>
        <section className='cd-card'>
          <header className='cd-section-head'><h2>Activity</h2></header>
          <dl className='cd-fields'>
            <dt>Loan Number</dt>
            <dd>
              <a href={this.getViewLoanUrl(data.loan?.id)}>{`${data.loan?.loanNumber || 'N/A'}`}</a>
            </dd>
            <dt>Activity Name</dt>
            <dd>{`${plan.activityConfigName || 'N/A'}`}</dd>
            <dt>Activity Weightage</dt>
            <dd>{`${shortDecimal(plan.weightage)}%`}</dd>
            <dt>Status</dt>
            <dd><span className={`cd-chip ${statusClass(plan.status)}`}>{plan.status || 'N/A'}</span></dd>
            <dt>Construction Plan Version</dt>
            <dd>{`${plan.version} (${isCurrentPlan ? 'Current Plan' : 'Old Plan'})`}</dd>
            <dt>Remarks</dt>
            <dd>{`${plan.remarks || 'N/A'}`}</dd>
          </dl>
        </section>
        <section className='cd-card'>
          <header className='cd-section-head'><h2>Property</h2></header>
          <dl className='cd-fields'>
            <dt>Property Details</dt>
            <dd>{`${property.propertyDescription || 'N/A'}`}</dd>
            <dt>Property Address</dt>
            <dd>{`${property.addressLine1} ${property.addressLine2} ${property.cityTown},  ${property.district}`}</dd>
            {property.lat ? (
              <>
                <dt>Property Location</dt>
                <dd>
                  <a href={mapsUrl(property.lat, property.lng)} target='_blank' rel='noopener noreferrer'>
                    {`${property.lat},${property.lng}`}
                  </a>
                </dd>
              </>
            ) : null}
            <dt>Verified at</dt>
            <dd>{`${plan.verifiedAt ? shortDate(plan.verifiedAt) : 'N/A'}`}</dd>
            {data.constructionPlan ? (
              <>
                <dt>Geo tagging</dt>
                <dd>{`${(plan.mapCircleRadius === '-1' || plan.mapCircleRadius === '-1.0') ? 'Disabled' : 'Enabled'}`}</dd>
              </>
            ) : null}
          </dl>
        </section>
      </div>
    );
  }

  renderMedia() {
    const {
      photos, videos, mediaTab, mediaAvailability,
    } = this.state;
    const available = MEDIA_TABS.filter((type) => mediaAvailability[type]);
    const current = MEDIA_TABS[mediaTab];
    const firstPhoto = photos[0];

    return (
      <section className='cd-card'>
        <header className='cd-section-head'>
          <h2>Progress media</h2>
          {available.length > 1 ? (
            <div className='cd-submitter' role='tablist' aria-label='Submitted by'>
              {available.map((type) => (
                <button
                  key={type}
                  type='button'
                  role='tab'
                  aria-selected={current === type}
                  className={current === type ? 'active' : ''}
                  onClick={() => this.selectSubmitter(type)}
                >
                  {type}
                </button>
              ))}
            </div>
          ) : null}
          {available.length === 1 ? (
            <span className='cd-submitted-by'>
              {'Submitted by '}
              <strong>{available[0]}</strong>
            </span>
          ) : null}
        </header>

        {firstPhoto && (firstPhoto.submittedDate || firstPhoto.lat) ? (
          <div className='cd-media-meta'>
            {firstPhoto.submittedDate ? (
              <div>
                <span>Submitted time</span>
                <strong>{`${shortDate(firstPhoto.submittedDate) || 'N/A'}`}</strong>
              </div>
            ) : null}
            {firstPhoto.lat ? (
              <div>
                <span>Media clicked location</span>
                <a
                  className='cd-link'
                  href={mapsUrl(firstPhoto.lat, firstPhoto.lng)}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {`${firstPhoto.lat},${firstPhoto.lng}`}
                </a>
              </div>
            ) : null}
          </div>
        ) : null}

        <div className='cd-media-group'>
          <h3>Images</h3>
          {photos.length > 0 ? (
            <div className='cd-grid'>
              {photos.map((element, index) => (
                <button
                  key={element.id}
                  type='button'
                  className='cd-tile'
                  title={element.disc || element.title}
                  onClick={() => {
                    this.setState({
                      currentImage: index,
                      viewerIsOpen: true,
                      selectedPhotos: photos,
                    });
                  }}
                >
                  <span className='cd-thumb'>
                    {element.src
                      ? <img src={element.src} alt={element.title} loading='lazy' />
                      : <CameraAltOutlinedIcon />}
                  </span>
                  <span className='cd-tile-title'>{element.title}</span>
                </button>
              ))}
            </div>
          ) : <div className='cd-empty'>No data available</div>}
        </div>

        <div className='cd-media-group'>
          <h3>Videos</h3>
          {videos.length > 0 ? (
            <div className='cd-grid'>
              {videos.map((element) => (
                <button
                  key={element.id}
                  type='button'
                  className='cd-tile'
                  title={element.disc || element.title}
                  onClick={() => {
                    this.setState({
                      videoUrl: element.src || videoAvatar,
                      videoOpen: true,
                      selectedVideodisc: element.disc,
                      selectedVideoTitle: element.title,
                    });
                  }}
                >
                  <span className='cd-thumb video'><PlayCircleFilledRoundedIcon /></span>
                  <span className='cd-tile-title'>{element.title}</span>
                </button>
              ))}
            </div>
          ) : <div className='cd-empty'>No data available</div>}
        </div>
      </section>
    );
  }

  render() {
    const {
      result, data, dataLoaded, showAlert,
      viewerIsOpen, currentImage, videoOpen, videoUrl,
      selectedPhotos,
      selectedVideodisc, selectedVideoTitle,
      formOpen, status,
      transferMediaOpen,
      selectedTransferMedia, modifyPlanOpen,
    } = this.state;
    verifyLogin();
    const detailsReady = dataLoaded === true && data && data.loanProperty;
    return (
      <div className='cd-page'>

        {result === true ? <Loading MainProps={this.props} /> : null}

        <ToastContainer />
        <CustomModal
          open={formOpen}
          setOpen={(value) => this.setState({ formOpen: value })}
          newForm={false}
          body={this.body()}
          handleSaveData={() => {
            if (status === 'Yet to start') {
              this.setState({ showAlert: true });
            } else {
              this.handleVerify();
            }
          }}
          title='Update Customer Request Status'
        />

        <Navbar MainProps={this.props} />

        <main className='cd-main'>
          {data.loan?.id ? (
            <a className='cd-back' href={this.getViewLoanUrl(data.loan.id)}>
              <ArrowBackRoundedIcon />
              {`Back to loan ${data.loan.loanNumber || ''}`.trim()}
            </a>
          ) : null}
          {this.renderNavigation()}

          {detailsReady ? (
            <>
              <section className='cd-card cd-summary'>
                <div className='cd-title'>
                  <h1>{data.constructionPlan?.activityConfigName || 'Construction details'}</h1>
                  {data.constructionPlan?.status ? (
                    <span className={`cd-chip ${statusClass(data.constructionPlan.status)}`}>
                      {data.constructionPlan.status}
                    </span>
                  ) : null}
                </div>
                {this.renderActions()}
              </section>
              {this.renderDetails()}
            </>
          ) : null}

          {this.renderMedia()}
        </main>

        <CustomAlert
          open={showAlert}
          handleYes={() => {
            this.setState({ showAlert: false });
            this.handleVerify('Yet to start');
          }}
          title='Reject Constrution Details'
          content={data.constructionPlan?.status === 'Verified' ? 'Are you sure you want to reject this request? It is already verified.' : 'Are you sure you want to reject this request?'}
          handleClose={() => {
            this.setState({ showAlert: false });
          }}
        />
        {transferMediaOpen ? (
          <TransferMedia
            open={transferMediaOpen}
            selectedTransferMedia={selectedTransferMedia}
            handleClose={(reload) => {
              if (reload) {
                this.setState({ mediaTab: 0 });
                this.getConstructionPlan(this.state.selectedConstructionPlanIndex,
                  this.state.selectedConstructionPlanId,
                  this.state.propertyId, this.state.selectedItem,
                  this.state.constructionPlanVersion);
              }
              this.setState({ transferMediaOpen: false });
            }}
          />
        ) : null}
        {modifyPlanOpen ? (
          <ModifyPlan
            open={modifyPlanOpen}
            selectedTransferMedia={selectedTransferMedia}
            handleClose={(reload) => {
              if (reload) {
                this.setState({ mediaTab: 0 });
                this.getConstructionPlan(this.state.selectedConstructionPlanIndex,
                  this.state.selectedConstructionPlanId,
                  this.state.propertyId, this.state.selectedItem,
                  this.state.constructionPlanVersion);
              }
              this.setState({ modifyPlanOpen: false });
            }}
          />
        ) : null}
        {viewerIsOpen && selectedPhotos.length > 0 && (
          <Lightbox
            onClose={() => this.setState({ viewerIsOpen: false, currentImage: 0 })}
            images={selectedPhotos}
            allowRotate={false}
            startIndex={currentImage}
            doubleClickZoom={0}
          />
        )}
        <VideoPlayer
          url={videoUrl}
          isOpen={videoOpen}
          disc={selectedVideodisc}
          title={selectedVideoTitle}
          onClose={() => this.setState({ videoOpen: false })}
        />
      </div>
    );
  }
}

export default ConstructionDetails;
